import classNames from "classnames";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import "./ButtonPill.css";
import Icon, { type MdIconName } from "./Icon";
import Tooltip from "./Tooltip";

type ButtonPillProp = {
    text: string;
    onClick?: () => void;
    dataTooltip?: string | null | undefined;
    icon?: MdIconName;
    loading?: boolean | null | undefined;
};

function composeLoading(): React.JSX.Element {
    return (
        <>
            <div className="button-pill__header-pill-icon-divider" />
            <LoadingSpinner />
        </>
    );
}

function composeIcon(icon: MdIconName, dataTooltip: string): React.JSX.Element {
    const IconComponent = Icon[icon].Medium;
    return (
        <>
            <div className="button-pill__header-pill-icon-divider" />
            <Tooltip placement="bottom" label={dataTooltip}>
                <IconComponent />
            </Tooltip>
        </>
    );
}

function ButtonPill(props: ButtonPillProp) {
    const { text, icon, dataTooltip, loading, onClick } = props;

    let iconState: React.JSX.Element | undefined;
    if (loading) {
        iconState = composeLoading();
    } else if (icon) {
        iconState = composeIcon(icon, dataTooltip ?? "");
    }

    return (
        <div
            className={classNames("button-pill__header-pill", {
                "button-pill--clickable": !!onClick,
            })}
            onClick={() => {
                // already loading, skip click interaction.
                if (loading) return;
                if (onClick) onClick();
            }}
        >
            <div className="button-pill__header-pill-text">{text}</div>
            {iconState}
        </div>
    );
}

export default ButtonPill;
